import React from 'react';
import GlobalStyles from '@xingternal/malt-global-styles';

const App = props => <GlobalStyles {...props} />;

App.displayName = 'App';

export default App;
